import { render, staticRenderFns } from "./accessAuthorization.vue?vue&type=template&id=d40e9ec4&scoped=true&"
import script from "./accessAuthorization.vue?vue&type=script&lang=js&"
export * from "./accessAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./accessAuthorization.vue?vue&type=style&index=0&id=d40e9ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40e9ec4",
  null
  
)

export default component.exports